export default __webpack_public_path__ + "static/media/money-receipt-template-4.7d86e68a.png";